import { render, staticRenderFns } from "./quanbudingdan.vue?vue&type=template&id=03b23fc5&scoped=true"
import script from "./quanbudingdan.vue?vue&type=script&lang=js"
export * from "./quanbudingdan.vue?vue&type=script&lang=js"
import style0 from "./quanbudingdan.vue?vue&type=style&index=0&id=03b23fc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b23fc5",
  null
  
)

export default component.exports